import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useReport } from "../../../tools/api";
import { LeftOutlined } from "@ant-design/icons";

const ListProgress = ({ reportList = [] }) => {
  return (
    <>
      <div className="holder-list-progress">
        <h3>گزارش عملکرد</h3>
        <ul>
          {reportList.map((item, key) => (
            <li key={key}>
              <div className="label">{item?.state}</div>
              <div className="value">
                <Link>
                  {item?.count} مورد <LeftOutlined />
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ListProgress;
